import "../../styles/home.scss";
import React, { ReactNode } from "react";
import { OpenTime } from "./openTime";
import { Title } from "../components/Title";
import more from "../../styles/images/home/8.png";
import edu from "../../styles/images/home/edu.png";
import home from "../../styles/images/home/home.png";
import lesson from "../../styles/images/home/lesson.png";
import china from "../../styles/images/home/china.png";
import { Link } from "react-router-dom";
import { HomeInfo } from "../../models/system";
import { Collection } from "./collection";
import order from "../../assets/images/Home/order.png";
import { ConnerCircleButton } from "../components/ConnerCircleButton";
import book from "../../assets/images/Home/book.png";
import { HomeBlock } from "./HomeBlock";
import { Search } from "../components/Search";
import { WebPager } from "../../components/WebPager";

import { webComponentDefine } from "../../components/webcomponents";

export class HomeBody extends React.Component<HomeInfo> {

    componentDidMount(): void {

        // var map = new BMapGL.Map("map");
        // var point = new BMapGL!.Point(121.140, 31.4626);
        // map.centerAndZoom(point, 18);
        // map.enableScrollWheelZoom(true);
        // var marker = new BMapGL.Marker(point);
        // map.addOverlay(marker);
    }

    virlink_click = () => {
        window.open(this.props.virtualUrl, "_blank");
    }


    render(): ReactNode {
        return (
            <section className="home">

                <Search className="homesearch"></Search>
                <OpenTime></OpenTime>

                <div className="top">
                    <div className="left">
                        <div className="top">
                            <img src={order} alt=""></img>
                            <p className="orderText">立即预约</p>
                            <p className="phone">{this.props.phone}</p>
                            <p className="time">咨询电话服务时间:08:00-17:00</p>
                        </div>


                        <div className="bottom withpadding">
                            <div className="centertitle">
                                <Title title="数字文物库" ></Title>
                            </div>

                            <div className="content">

                                <img className="right" src={book} alt=""></img>
                                <Link to={"/views/saving"} className="di_show" ><ConnerCircleButton title="点击查看"></ConnerCircleButton></Link>
                            </div>
                        </div>
                    </div>


                    <div className="right withpadding" onClick={(e) => window.location.href = "/views/shows/temp"}>
                        <Title title="临时展览"></Title>
                        <div className="time">时间：2022年10月1日--2022年10月7日</div>
                    </div>

                </div>

                <div className="mid">
                    <div className="left broeadcast withpadding">
                        <Title title="最新公告">
                            <Link to={"/views/infos/Publisher"}><img src={more} alt="了解更多"></img></Link>
                        </Title>
                        <ul className="content">
                            {
                                this.props.publicInfos?.map(x => <li><span><Link to={"/views/infos/publishdetial/" + x.id}>{x.title}</Link></span><span>{x.date}</span></li>)
                            }

                        </ul>
                    </div>
                    <div className="right withpadding">
                        <Title title="虚拟博物馆"></Title>
                        <img className="nopadding" src={china} alt=""></img>
                        <a href={this.props.virtualUrl} className="enterBtn">点击进入</a>

                    </div>
                </div>
                <div className="bottom">

                    <div className="collect_container ">

                        <div className="collect_home">
                            <Title title="馆藏精品"></Title>
                            <div >
                                <div className="left">

                                    <Link to={"/views/saving"} ><ConnerCircleButton title="点击查看"></ConnerCircleButton></Link>
                                </div>

                            </div>
                        </div>



                        {/* <Link to={"/views/saving"} className="more"></Link>
                        <Link to={"/views/saving"} className="more1"></Link>
                        <Link to={"/views/saving"} className="more2"></Link>
                        <Link to={"/views/saving"} className="more3"></Link> */}

                        <Collection  {...this.props} ></Collection>
                    </div>
                    <div className="bottom">
                        <div className="left withpadding">
                            <Title title="交通指南"></Title>
                            <p className="address"><span>地址：{this.props.address}</span></p>
                            <p className="bus"><span>公交：115、122、128、138、202、207、137（夜线）、211（夜线）、市政府上海路站均可到达。</span></p>

                        </div>
                        <div className="right " id="map">

                        </div>
                    </div>
                </div>


            </section>
        );
    }
}